import { useCallback, useState } from 'react';
import UserInfoProvider from 'reporting-ui-components/components/PlatformReport/UserInfoProvider';
import { useIndexPageInlineSidebar } from '../app/components/IndexPageInlineSidebar';
import { ColumnInsightsContent } from './ColumnInsightsContent';
import { jsx as _jsx } from "react/jsx-runtime";
export const ColumnInsightsSidebarWrapper = () => {
  /*
   * This is a workaround to force the component and underlying useAsyncData hook from reporting to re-render when the generate button is clicked.
   */
  const [generateTrigger, setGenerateTrigger] = useState(0);
  const handleGenerate = useCallback(() => {
    setGenerateTrigger(prev => prev + 1);
  }, []);

  // Get typed data for the columnInsights sidebar
  const {
    getSidebarData
  } = useIndexPageInlineSidebar();
  const columnInsightsData = getSidebarData('columnInsights');
  if (!columnInsightsData) {
    return null;
  }
  const {
    columnName,
    filterGroups,
    query,
    objectTypeId
  } = columnInsightsData;
  if (!columnName || !filterGroups || !objectTypeId) {
    return null;
  }
  return /*#__PURE__*/_jsx(UserInfoProvider, {
    children: /*#__PURE__*/_jsx(ColumnInsightsContent, {
      handleGenerate: handleGenerate,
      columnName: columnName,
      filterGroups: filterGroups,
      query: query,
      objectTypeId: objectTypeId
    }, generateTrigger)
  });
};